module.exports = __webpack_public_path__ + "media/images/payment/paypal-8d6d00222535fd829c9e051380b26542.svg";